import * as React from 'react'

const Spacer = ({ blok }) => {
  const { height } = blok

  return <div className="spacer" style={{ height: `${height}px` }} />
}

export default Spacer
